import {EVENT} from './edapEventsConstantsLegacy';

const hitPropertiesToEdapLabelFieldsMap = {
    card_title: 'headline',
    card_text: 'accommodations',
    im_url: 'imageUrl',
    link: 'propertyHref',
    rrm: 'clientRequestId',
    position: 'cardIndex',
    lid: 'listingId',
};

const edapLabelFields = {
    cardTitle: 'card_title',
    cardText: 'card_text',
    imUrl: 'im_url',
    link: 'link',
    rrm: 'rrm',
    position: 'position',
    lid: 'lid',
    actionlocation: 'actionlocation',
    eventlbsuuid: 'eventlbsuuid',
    eventrefinements: 'eventrefinements',
};

const cardClickEventFields = [
    edapLabelFields.lid,
    edapLabelFields.position,
    edapLabelFields.link,
    edapLabelFields.rrm,
];

const cardViewEventFields = [
    edapLabelFields.lid,
    edapLabelFields.position,
    edapLabelFields.imUrl,
    edapLabelFields.cardText,
    edapLabelFields.cardTitle,
    edapLabelFields.rrm,
];

/**
 *
 * @param hit {object} - object storing data about a listing
 * @param fieldsToExtract {string[]} - array of fields that need to be extracted from hit
 * @returns {*} - object with properly named fields for {@link getLabel} to process,
 * i.e, hit.accommodations --> card_text {@link hitPropertiesToEdapLabelFieldsMap}
 */

const hitToEdapLabelData = (hit = {}, fieldsToExtract = []) =>
    fieldsToExtract.reduce((edapFields, newField) => {
        const newFieldValue = hit[hitPropertiesToEdapLabelFieldsMap[newField]];
        if (newFieldValue) {
            return {
                ...edapFields,
                [newField]: hit[hitPropertiesToEdapLabelFieldsMap[newField]],
            };
        }

        return edapFields;
    }, {});

/**
 *
 * @param params {object} - object with values to form an event label
 * @returns {{eventlabel: string}}
 */

const getLabel = (params = {}) => {
    return Object.entries(params).reduce(
        (result, [key, value]) => {
            if (value) {
                result.eventlabel += `${key}='${value}';`;
            }
            return result;
        },
        {eventlabel: ''}
    );
};

const getLabelData = (fields) => (hit) => hitToEdapLabelData(hit, fields);
const getCardViewEventLabelData = getLabelData(cardViewEventFields);
const getCardClickEventLabelData = getLabelData(cardClickEventFields);

const triggerEdapEventLegacy = (
    context,
    {event = EVENT, fields = {}} = {},
    eventOptions = {}
) => {
    if (context.hasProvider) {
        context.trigger(event, fields, eventOptions);
    } else {
        window.edap = window.edap || [];
        window.edap.push((edap) => {
            edap.trigger(event, fields, eventOptions);
        });
    }
};

export {
    edapLabelFields,
    getCardClickEventLabelData,
    getCardViewEventLabelData,
    getLabel,
    hitToEdapLabelData,
    triggerEdapEventLegacy,
};
